import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { deleteProduct } from "../lib/upcData";
import { getTaskContextByKey } from "../../../task-list/lib/taskData";
import * as notify from "../../../../shared/notify";

export class DeleteProduct extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isFinalized: false,
        };
    }

    deleteUpc = async (e) => {
        e.stopPropagation();
        const shipmentProducts = await getTaskContextByKey(this.props.shipmentKey);
        const finalizedProduct = shipmentProducts.find((x) => x.shipmentProductKey === this.props.productKey);

        if (finalizedProduct && finalizedProduct.isFinalized) {
            notify.error("You cannot delete a finalized product.");
            this.setState({
                isFinalized: true,
            });

            return;
        } else {
            const response = await deleteProduct(this.props.shipmentKey, this.props.productKey);

            if (!response) {
                return;
            }

            this.props.deleteUpc(this.props.productKey);
        }
    };

    render() {
        const deleteButton =
            this.state.isFinalized || this.props.disabled ? null : (
                <button className="button -text" onClick={this.deleteUpc}>
                    <FontAwesomeIcon icon={faTrash} />
                </button>
            );

        return <div>{deleteButton}</div>;
    }
}
